import React from "react";
import { useLocation, Navigate, Link } from "react-router-dom";

const POLICIES = {
  "refund-policy": {
    title: "Refund Policy",
    body: `Lyon's Den Protection provides spiritual services, consultations, readings, and handcrafted spiritual products.

Due to the time, preparation, and energetic work involved in providing services, completed readings, consultations, and spiritual services are non-refundable.

PHYSICAL PRODUCTS
Unused and unopened physical products may be eligible for return or exchange within 14 days of delivery. Customers must contact Lyon's Den Protection before returning any product.

Custom-made products, custom spiritual work, personalized items, and specially prepared spiritual products are non-refundable.

Damaged shipments must be reported within 48 hours of delivery.`,
  },
  "cancellation-policy": {
    title: "Cancellation & Rescheduling Policy",
    body: `Appointments may be rescheduled with at least 24 hours notice.

Appointments canceled with less than 24 hours notice may forfeit any deposit or payment made.

No-shows are not eligible for refunds.

Lyon's Den Protection reserves the right to reschedule appointments due to emergencies, illness, weather conditions, travel issues, or unforeseen circumstances.

Customers arriving more than 15 minutes late may need to reschedule their appointment.`,
  },
  "terms": {
    title: "Terms of Service",
    body: `By booking a service or purchasing a product from Lyon's Den Protection, customers agree to these terms.

Services are provided for spiritual guidance, educational purposes, and personal insight.

Customers must be at least 18 years old to purchase services unless accompanied by a parent or legal guardian.

Customers are responsible for their own decisions and actions.

Lyon's Den Protection reserves the right to refuse service to anyone engaging in abusive, threatening, fraudulent, or inappropriate behavior.`,
  },
  "privacy": {
    title: "Privacy Policy",
    body: `Lyon's Den Protection respects customer privacy.

Personal information collected through bookings, purchases, contact forms, newsletters, and consultations will be used only for business operations, appointment management, customer support, and marketing communications.

Customer information will never be sold to third parties.

Customers may request removal from marketing communications at any time.`,
  },
  "disclaimer": {
    title: "Spiritual Services Disclaimer",
    body: `Lyon's Den Protection provides spiritual guidance, education, tarot readings, consultations, and related services.

Services are intended for personal growth, reflection, spiritual exploration, and entertainment purposes.

No service, reading, consultation, product, or recommendation should be considered legal, medical, psychological, financial, or professional advice.

Lyon's Den Protection does not guarantee specific outcomes, results, predictions, or life events.

All decisions made by clients remain their sole responsibility.

By using this website and booking services, clients acknowledge and accept these terms.`,
  },
};

export default function LegalPage() {
  const loc = useLocation();
  const slug = loc.pathname.replace(/^\//, "");
  const p = POLICIES[slug];
  if (!p) return <Navigate to="/" replace />;

  return (
    <div className="py-20 md:py-28 px-6 md:px-10 max-w-3xl mx-auto" data-testid={`legal-${slug}-page`}>
      <Link to="/" className="overline text-[#D4AF37]">← Home</Link>
      <h1 className="font-serif text-4xl md:text-5xl tracking-tight mt-6">{p.title}</h1>
      <div className="gold-rule my-8" />
      <div className="text-white/80 leading-relaxed text-lg whitespace-pre-line font-serif">{p.body}</div>
      <div className="mt-12 pt-6 border-t border-white/10 text-sm text-white/50">
        <div>Other policies:</div>
        <div className="mt-3 flex flex-wrap gap-3">
          {Object.entries(POLICIES).filter(([s]) => s !== slug).map(([s, v]) => (
            <Link key={s} to={`/${s}`} className="hover:text-[#D4AF37]" data-testid={`legal-${s}-link`}>{v.title}</Link>
          ))}
        </div>
      </div>
    </div>
  );
}
